/**
 * TanStack Query hooks for `landing-pages`. Thin wrappers over ./api with
 * automatic invalidation of the `landing-pages` list after any mutation.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	landingPagesQueryKeys,
	type CreateLandingPageInput,
	type ListLandingPagesResponse,
	type LandingPageRow,
} from "./api";

export function useLandingPagesList(): UseQueryResult<
	ListLandingPagesResponse,
	Error
> {
	return useQuery({
		queryKey: landingPagesQueryKeys.list(),
		queryFn: list,
	});
}

export function useLandingPagesCreate(): UseMutationResult<
	LandingPageRow,
	Error,
	CreateLandingPageInput
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: landingPagesQueryKeys.all });
		},
	});
}

export function useLandingPagesDelete(): UseMutationResult<
	{ removed: boolean },
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: landingPagesQueryKeys.all });
		},
	});
}
